module.exports = __webpack_public_path__ + "static/menu-4bf3cac5b75fe273ee2528dbb1993aab.jpg";